var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHourglass = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "18px",
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3461768E-772E-48DB-8306-49A14E0DCF96") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Wireframes-2.0",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "hourglass",
    transform: "translate(-1150.000000, -809.000000)",
    filter: "url(#filter-1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1151.000000, 810.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.875,16 L0.625,16 C0.28,16 0,15.7243077 0,15.3846154 C0,15.0449231 0.28,14.7692308 0.625,14.7692308 L11.875,14.7692308 C12.22,14.7692308 12.5,15.0449231 12.5,15.3846154 C12.5,15.7243077 12.22,16 11.875,16 Z",
    id: "Path",
    stroke: "#979797",
    strokeWidth: 0.3,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625,12.9230769 C10.28,12.9230769 10.0003125,12.648 10,12.3086154 C9.9975,10.6227692 8.26625,9.65107692 6.6434375,8.87292308 C6.4278125,8.76953846 6.19875,8.66430769 5.961875,8.556 C3.975,7.64430769 1.2540625,6.39569231 1.24999974,3.69323077 C1.2496875,3.35353846 1.5290625,3.07753846 1.8740625,3.07692308 L1.875,3.07692308 C2.2196875,3.07692308 2.4996875,3.352 2.5,3.69138462 C2.5028125,5.61076923 4.62125,6.58246154 6.49,7.44030769 C6.7334375,7.552 6.9690625,7.66030769 7.1909375,7.76676923 C8.6084375,8.44646154 11.2465625,9.71138462 11.2503128,12.3070769 C11.250625,12.6467692 10.97125,12.9227692 10.62625,12.9233846 C10.625625,12.9230769 10.6253125,12.9230769 10.625,12.9230769 L10.625,12.9230769 Z",
    id: "Path",
    stroke: "#979797",
    strokeWidth: 0.3,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.875,12.9230769 C1.8746875,12.9230769 1.874375,12.9230769 1.8740625,12.9230769 C1.5290625,12.9224615 1.249375,12.6467692 1.24999895,12.3067692 C1.2540625,9.60430769 3.975,8.35569231 5.961875,7.444 C6.19875,7.33538462 6.4278125,7.23046154 6.6434375,7.12707692 C8.26625,6.34892308 9.9975,5.37753846 10,3.69138462 C10.0003125,3.352 10.2803125,3.07692308 10.625,3.07692308 L10.6259375,3.07692308 C10.9709375,3.07753846 11.250625,3.35323077 11.249999,3.69323077 C11.24625,6.28892308 8.608125,7.55384615 7.190625,8.23353846 C6.96875,8.34 6.7334375,8.448 6.4896875,8.56 C4.62125,9.41723077 2.5028125,10.3892308 2.5,12.3086154 C2.4996875,12.648 2.2196875,12.9230769 1.875,12.9230769 Z",
    id: "Path",
    stroke: "#979797",
    strokeWidth: 0.3,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625,16 C10.28,16 10,15.7243077 10,15.3846154 L10,12.3076923 C10,11.968 10.28,11.6923077 10.625,11.6923077 C10.97,11.6923077 11.25,11.968 11.25,12.3076923 L11.25,15.3846154 C11.25,15.7243077 10.97,16 10.625,16 Z",
    id: "Path",
    stroke: "#979797",
    strokeWidth: 0.3,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.875,16 C1.53,16 1.25,15.7243077 1.25,15.3846154 L1.25,12.3076923 C1.25,11.968 1.53,11.6923077 1.875,11.6923077 C2.22,11.6923077 2.5,11.968 2.5,12.3076923 L2.5,15.3846154 C2.5,15.7243077 2.22,16 1.875,16 Z",
    id: "Path",
    stroke: "#979797",
    strokeWidth: 0.3,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.625,4.30769231 C10.28,4.30769231 10,4.032 10,3.69230769 L10,0.615384615 C10,0.275692308 10.28,0 10.625,0 C10.97,0 11.25,0.275692308 11.25,0.615384615 L11.25,3.69230769 C11.25,4.032 10.97,4.30769231 10.625,4.30769231 Z",
    id: "Path",
    stroke: "#979797",
    strokeWidth: 0.3,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.875,4.30769231 C1.53,4.30769231 1.25,4.032 1.25,3.69230769 L1.25,0.615384615 C1.25,0.275692308 1.53,0 1.875,0 C2.22,0 2.5,0.275692308 2.5,0.615384615 L2.5,3.69230769 C2.5,4.032 2.22,4.30769231 1.875,4.30769231 Z",
    id: "Path",
    stroke: "#979797",
    strokeWidth: 0.3,
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.875,1.23076923 L0.625,1.23076923 C0.28,1.23076923 0,0.955076923 0,0.615384615 C0,0.275692308 0.28,0 0.625,0 L11.875,0 C12.22,0 12.5,0.275692308 12.5,0.615384615 C12.5,0.955076923 12.22,1.23076923 11.875,1.23076923 Z",
    id: "Path",
    stroke: "#979797",
    strokeWidth: 0.3,
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHourglass);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hourglass.7e5a6211d04aea6686a3643573e6ce76.svg";